import React from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

const templateOverviewCard = EntityCardBlueprint.make({
  name: 'template-overview',
  params: {
    filter: 'kind:template',
    loader: async () => {
      const { TemplateOverviewCard } = await import('./TemplateOverviewCard');
      return compatWrapper(React.createElement(TemplateOverviewCard));
    },
  },
});

export const templateOverviewPlugin = createFrontendPlugin({
  pluginId: 'template-overview',
  extensions: [templateOverviewCard],
});
